import memoizeOne from 'memoize-one';
import DataSource from '~/Api/DataSource/DataSource';
import ProductPrice from '~/Api/Product/ProductPrice';

import ActualPackStatus from './ActualPackStatus';
import UnitPrice from '~/Api/Product/UnitPrice';
import TreatmentCost from '~/Api/Product/TreatmentCost';

export default class ActualPack {
	id: string;

	dataSource: DataSource;

	companyName: string | null;

	hasPrices: boolean;

	prices: ProductPrice[];

	packageSizeForSingleUnit: number;

	status: ActualPackStatus;

	unitPrice: UnitPrice | null;

	treatmentCost: TreatmentCost | null;

	constructor(
		id: string,
		dataSource: DataSource,
		companyName: string | null,
		hasPrices: boolean,
		prices: ProductPrice[],
		packageSizeForSingleUnit: number,
		status: ActualPackStatus,
		unitPrice: UnitPrice | null,
		treatmentCost: TreatmentCost | null
	) {
		this.id = id;
		this.dataSource = dataSource;
		this.companyName = companyName;
		this.hasPrices = hasPrices;
		this.prices = prices;
		this.packageSizeForSingleUnit = packageSizeForSingleUnit;
		this.status = status;
		this.unitPrice = unitPrice;
		this.treatmentCost = treatmentCost;
	}

	get lowestPrice(): ProductPrice | null {
		const prices = [...this.prices];
		prices.sort((a, b) => Number(a.price?.value ?? 0) - Number(b.price?.value ?? 0));
		return prices[0] ?? null;
	}

	get pricesMap(): { [type: string]: ProductPrice } {
		return this.buildPricesMap(this.prices);
	}

	buildPricesMap = memoizeOne((prices: ProductPrice[]): { [type: string]: ProductPrice } => {
		return prices.reduce((map: { [key: string]: ProductPrice }, price) => {
			map[price.type] = price;
			return map;
		}, {});
	});
}
